import FEEDBACK_CONSTANTS from '@/constants/feedbackConstants';

export default {
  heading: 'Ďakujeme za vaše hodnotenie!',
  text: 'Môžeme niečo zlepšiť? Podeľte sa s nami o svoj názor.',
  form: {
    fields: [
      {
        type: 'textarea',
        name: FEEDBACK_CONSTANTS.FEEDBACK_NAME,
        placeholder: 'Váš názor...'
      }
    ],
    submit: {
      label: 'Odoslať'
    }
  }
};
